// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nl-0";
export var animationContainer = "_nl-1";
export var itemPrice = "_nl-a";
export var itemizedContent = "_nl-9";
export var itemizedHeader = "_nl-7";
export var itemizedRow = "_nl-8";
export var itemizedSection = "_nl-6";
export var modalContent = "_nl-2";
export var orderName = "_nl-3";
export var refundOption = "_nl-4";
export var refundOptionsContainer = "_nl-5";
export var shippingLabel = "_nl-b";
export var totalRow = "_nl-c";